export type AdditionalDriverStatus =
  | 'not_sent_yet'
  | 'invite_sent'
  | 'in_review'
  | 'verified'
  | 'rejected';

export const ADDITIONAL_DRIVER_STATUS_LABELS: Record<
  AdditionalDriverStatus,
  string
> = {
  // Client-only: an email staged on the manage page but not yet invited.
  not_sent_yet: 'Not sent yet',
  invite_sent: 'Invite sent',
  in_review: 'In review',
  verified: 'Verified',
  rejected: 'Rejected',
};

// The API sends display labels ("Invite sent"), so normalize them to keys.
export function additionalDriverStatus(
  driver: { status?: string } | null | undefined
): AdditionalDriverStatus | null {
  if (!driver?.status) return null;

  const normalized = driver.status.toLowerCase().replace(/\s+/g, '_');

  if (normalized in ADDITIONAL_DRIVER_STATUS_LABELS) {
    return normalized as AdditionalDriverStatus;
  }

  return null;
}

export function findAdditionalDriver<T extends { id?: number | null }>(
  drivers: T[] | undefined,
  customer: { id: number } | null | undefined
) {
  if (!drivers || !customer) return undefined;

  return drivers.find((driver) => driver.id === customer.id);
}

export function isAdditionalDriverVerified(
  driver: { status?: string } | null | undefined
) {
  return additionalDriverStatus(driver) === 'verified';
}
